export enum FilterOperator {
    EQUALS = "is",
    CONTAINS = "contains",
    GREATER_THAN_OR_EQUAL = "gte",
    LESS_THAN_OR_EQUAL = "lte",
    IN = "in",
    NOT_IN = "not in",
    NOT_EQUALS = "is not",
    NOT_CONTAINS = "not contains",
    NONE = "none"
  }
  